function getVisibleCalibrationAssetIds(records) {
  return (records || [])
    .filter(function (record) {
      return record && record['@rid'];
    })
    .map(function (record) {
      return record['@rid'];
    });
}

function hasVisibleCalibrationAssets(records) {
  return getVisibleCalibrationAssetIds(records).length > 0;
}

module.exports = {
  getVisibleCalibrationAssetIds,
  hasVisibleCalibrationAssets
};
